import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, shareReplay, throttleTime } from 'rxjs/operators';
import { DashboardData, DashboardResponse } from '../types';

@Injectable({
  providedIn: 'root',
})
export class StatsV2Service {
  private hauliStats$$ = new BehaviorSubject<DashboardData[]>([]);
  private hauliStatsThrottle$$ = new Subject();
  private hauliStatsShared$ = this.hauliStats$$.pipe(shareReplay(1));

  public get hauliStats$(): Observable<DashboardData[]> {
    this.hauliStatsThrottle$$.next();
    return this.hauliStatsShared$;
  }

  private reloadStats$$ = new BehaviorSubject<DashboardData[]>([]);
  private reloadStatsThrottle$$ = new Subject();
  private reloadStatsShared$ = this.reloadStats$$.pipe(shareReplay(1));

  public get reloadStats$(): Observable<DashboardData[]> {
    this.reloadStatsThrottle$$.next();
    return this.reloadStatsShared$;
  }

  constructor(private httpClient: HttpClient) {
    this.reloadStatsThrottle$$.pipe(throttleTime(1000)).subscribe(() => {
      this.loadReloadStats();
    });
    this.hauliStatsThrottle$$.pipe(throttleTime(1000)).subscribe(() => {
      this.loadHauliStats();
    });
  }

  private async loadReloadStats() {
    const resp = await this.httpClient
      .get<DashboardResponse>(`${environment.api}/v2/admin/reload_stats`)
      .pipe(map((value) => value.dashboardData))
      .toPromise();
    this.reloadStats$$.next(resp);
  }

  private async loadHauliStats() {
    const resp = await this.httpClient
      .get<DashboardResponse>(`${environment.api}/v2/admin/hauli_stats`)
      .pipe(map((value) => value.dashboardData))
      .toPromise();
    this.hauliStats$$.next(resp);
  }
}
